import { AiEffectStatusEnum, AiOrderDirectionEnum, AiSourceEnum, FuturesTradeRecordStatusEnum } from "@/utils/SuperEnum";
import { request } from "../request";

//#region  AI相关

/**
 * 创建AI单
 */
export type InputCreateAiOrder = {
  /**
   * AI商品ID
   */
  AiProductId: number;
  /**
   * 产品ID
   */
  ProductId: number,
  /**
   * 购买的费用
   */
  BuyCost: number
};



export function fetchCreateAiOrderForUserAsync(input: InputCreateAiOrder) {
  return request({
    url: '/Order/CreateAiOrderForUser',
    method: 'post',
    data: input
  })
}

/**
 * 获取AI订单已使用的数量 
 */
export function fetchGetMyAiOrderLimitFromAiProducIdAsync(aiProductId: number) {
  return request<{
    useCount: number
  }>({
    url: '/Order/GetMyAiOrderLimitFromAiProducId',
    method: "get",
    params: {
      aiProductId
    }
  });
}


export type InputGetAiOrderListQueryFilter = {
  NickName?: string;
  Phone?: string;
  Email?: string;
  Uid?: string;
  Source?: string;
  /**
   * 生效状态
   */
  EffectStatus?: string;
  StartTime?: number;
  EndTime?: number;
};




export type InputAddAiOrder = {
  Phone?: string;
  ProductId?: number;
  /**
   * 购买费用
   */
  BuyCost?: number;
  /**
   * 盈利比例
   */
  ProfitRatio?: number;
  /**
   * 秒
   */
  DurationSec?: number;
};

export type OutputGetMyAiOrderList = {
  Product: {
    Qcdn: string,
    Bcdn: string,
    Dn: string,
    IconUrl: string
    ProductCode: string,
  },
  AiProduct: {
    Title: string,
    Icon: string
  }
} & DB.AiOrder;

/**
 * 获取我当前的AI订单列表
 * @param page 
 * @param pageSize 
 * @param effectStatus 
 * @returns 
 */
export function fetchGetMyAiOrderListAsync(page: number, pageSize: number, effectStatus: '' | 'pending' | 'active' | 'finish') {
  return request<{
    total: number,
    list: OutputGetMyAiOrderList[]
  }>({
    url: '/Order/GetMyAiOrderList',
    method: "get",
    params: {
      page,
      pageSize,
      effectStatus
    }
  });
}


//#region 现货相关

export type InputCreateSppotTradeRecordsForUser = {
  /**
   * 购买或卖出
   */
  Side: "buy" | "sell";
  /**
   * 产品ID
   */
  ProductId: number | string;
  /**
   * 市场金额 / 固定金额
   */
  SideType: "market_price" | "fixed_price",
  /**
   * 购买单价(用于固定价格参数,其实是就开仓价)
   */
  BuyUnitPrice: number;
  /**
   * 购买手数
   */
  LotSize: number;
};


/**
 * 创建现货交易
 */
export function fetchCreateSppotTradeRecordsForUserAsync(input: InputCreateSppotTradeRecordsForUser) {
  return request({
    url: '/Order/CreateSppotTradeRecordsForUser',
    method: 'post',
    data: input
  });
}

export type InputGetSpotTradeRecordsListForUserQueryFilter = {

};

export type OutputSpotTradeRecordsList = {
  Product: {
    Dn: string,
    ProductCode: string,
    IconUrl: string
  }
} & DB.SpotTradeRecords;
/**
 * 获取现货交易记录
 * @param page 当前页
 * @param pageSize 每页个数
 * @param input 
 * @returns 
 */
export function fetchGetSpotTradeRecordsListForUserAsync(page: number, pageSize: number, input: InputGetSpotTradeRecordsListForUserQueryFilter) {
  return request<{
    total: number,
    list: OutputSpotTradeRecordsList[]
  }>({
    url: '/Order/GetSpotTradeRecordsListForUser',
    method: "post",
    data: input,
    params: {
      page,
      pageSize
    }
  });
}

/**
 * 取消现货订单
 * @param orderId 现货订单ID
 */
export function fetchCancelSppotTradeRecordsForUserAsync(orderId: string) {
  return request({
    url: '/Order/CancelSppotTradeRecordsForUser',
    method: 'get',
    params: {
      orderId
    }
  });
}

/**
 * 现货平仓
 */
export function fetchCloseSpotTradeRecordsForUserAsync(orderId: string) {
  return request({
    url: '/Order/CloseSpotTradeRecordsForUser',
    method: 'get',
    params: {
      orderId
    }
  });
}

export type InputSetStopLossSpotTradeRecords = {
  OrderId: string,
  TakeProfitPrice: string | number,
  StopLossPrice: string | number
};

export function SetStopSpotTradeTradeRecordsAsync(input: InputSetStopLossFuturesTradeRecords) {
  return request({
    url: '/Order/SetStopSpotTradeTradeRecords',
    method: 'post',
    data: input
  });
}



//#endregion

//#region 合约相关
/**
 * 合约交易输入
 */
export type InputCreateFuturesTradeRecordsForUser = {
  /**
   * 购买或卖出
   */
  Side?: "buy" | "sell",
  /**
   * 产品ID
   */
  ProductId?: number;
  /**
   * 市场金额 / 固定金额
   */
  SideType?: "market_price" | "fixed_price",
  /**
   * 购买单价(用于固定价格参数,其实是就开仓价)
   */
  BuyUnitPrice: number;
  /**
   * 购买手数
   */
  LotSize?: number;
  /**
   * 倍率
   */
  Leverage?: number;
}

/**
 * 创建合约交易
 */
export function fetchCreateFuturesTradeRecordsForUserAsync(input: InputCreateFuturesTradeRecordsForUser) {
  return request({
    url: '/Order/CreateFuturesTradeRecordsForUser',
    method: 'post',
    data: input
  })
}

/**
 * 取消订单
 */
export function fetchCancelFuturesTradeRecordsForUserAsync(orderId: string) {
  return request({
    url: "/Order/CancelFuturesTradeRecordsForUser",
    method: "get",
    params: {
      orderId
    }
  });
}

/**
 * 手动闭仓
 */
export function fetchCloseFuturesTradeRecordsForUserAsync(orderId: string) {
  return request({
    url: "/Order/CloseFuturesTradeRecordsForUser",
    method: "get",
    params: {
      orderId
    }
  });
}

export type InputSetStopLossFuturesTradeRecords = {
  OrderId: string,
  TakeProfitPrice: string | number,
  StopLossPrice: string | number
};

/**
 * 设置止损
 * @returns 
 */
export function fetchSetStopLossFuturesTradeRecordsAsync(input: InputSetStopLossFuturesTradeRecords) {
  return request<InputSetStopLossFuturesTradeRecords>({
    url: "/Order/SetStopLossFuturesTradeRecords",
    method: "post",
    data: input
  });
}


export type InputGetFuturesTradeRecordsListForUserQueryFilter = {
  /**
  none 取消订单
  pending 等待(委托中)
  open     持仓中
  closed   已平仓
  liquidated 强平
   */
  Status?: "none" | "pending" | "open" | "closed" | "liquidated"
}

export type OutputFuturesTradeRecordsList = {
  Product: {
    Dn: string,
    ProductCode: string,
    IconUrl: string
  }
} & DB.FuturesTradeRecords;

/**
 * 获取合约交易记录
 * @param input 
 * @returns 
 */
export function fetchGetFuturesTradeRecordsListForUser(page: number, pageSize: number, input: InputGetFuturesTradeRecordsListForUserQueryFilter) {
  return request<{
    total: number,
    list: OutputFuturesTradeRecordsList[]
  }>({
    url: '/Order/GetFuturesTradeRecordsListForUser',
    method: "post",
    data: input,
    params: {
      page,
      pageSize
    }
  });
}

//#endregion

//#region 期权相关

export type InputCreateOptionsTradeRecordsForUser = {
  /**
   * 方向
   */
  Direction: "up" | "down";
  /**
   * 
   */
  DurationType: "point" | "second";
  /**
   * 时效值
   */
  DurationValue: number;
  /**
   * 产品ID
   */
  ProductId: number;
  /**
   * 投资金额
   */
  InvestmentAmount: number;
};

/**
 * 创建期权交易
 * @param input 
 */
export function fetchCreateOptionsTradeRecordsForUserAsync(input: InputCreateOptionsTradeRecordsForUser) {
  return request({
    url: '/Order/CreateOptionsTradeRecordsForUser',
    method: 'post',
    data: input
  })
}



export type InputGetOptionsTradeRecordsListForUserQueryFilter = {
  Status?: "" | "open" | "close"
};

export type OutputOptionsTradeRecordsList = {
  Product: {
    Dn: string,
    ProductCode: string,
    IconUrl: string
  }
} & DB.OptionsTradeRecords;

export type OutputOptionsTradeRecords = {

} & OutputOptionsTradeRecordsList;

/**
 * 获取期权交易记录
 * @param page 当前页
 * @param pageSize 每页个数
 * @param input 
 * @returns 
 */
export function fetchGetOptionsTradeRecordsListForUserAsync(page: number, pageSize: number, input: InputGetOptionsTradeRecordsListForUserQueryFilter) {
  return request<{
    total: number,
    list: OutputOptionsTradeRecordsList[]
  }>({
    url: '/Order/GetOptionsTradeRecordsListForUser',
    method: "post",
    data: input,
    params: {
      page,
      pageSize
    }
  });
}

/**
 * 根据期权订单ID获取期权详情数据
 * @param orderId 
 */
export function fetchGetOptionsTradeDataFromOrderID(orderId: string) {
  return request<OutputOptionsTradeRecords>({
    url: '/Order/GetOptionsTradeDataFromOrderID',
    method: "post",
    data: {
      orderId
    }
  });
}

//#endregion